var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000004561(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0028 39.5L14.9972 39.5C14.9973 39.5 14.9902 39.5 14.9747 39.4969C14.9591 39.4938 14.9373 39.4879 14.9086 39.4775C14.8503 39.4562 14.7741 39.4198 14.6791 39.3624C14.4879 39.247 14.252 39.066 13.9743 38.8156C13.42 38.316 12.7448 37.5819 11.9905 36.6641C10.4842 34.8316 8.69939 32.3125 6.98811 29.5912C5.27703 26.8702 3.64737 23.9595 2.44747 21.3458C1.23643 18.7078 0.5 16.4486 0.5 15C0.5 6.99239 6.99239 0.5 15 0.5C23.0076 0.5 29.5 6.99239 29.5 15C29.5 16.4265 28.762 18.6742 27.5474 21.3092C26.3444 23.9193 24.7109 26.8328 22.9973 29.5594C21.2835 32.2863 19.4972 34.8136 17.9924 36.6531C17.2388 37.5743 16.5651 38.3116 16.013 38.8136C15.7364 39.0651 15.5018 39.247 15.3122 39.3629C15.218 39.4205 15.1427 39.457 15.0856 39.4781C15.027 39.4998 15.0018 39.5 15.0028 39.5ZM11.75 15C11.75 13.2049 13.2049 11.75 15 11.75C16.7951 11.75 18.25 13.2049 18.25 15C18.25 16.7951 16.7951 18.25 15 18.25C13.2049 18.25 11.75 16.7951 11.75 15ZM8.25 15C8.25 18.7287 11.2727 21.75 15 21.75C18.7273 21.75 21.75 18.7287 21.75 15C21.75 11.2713 18.7273 8.25 15 8.25C11.2727 8.25 8.25 11.2713 8.25 15Z",
    fill: "#ED0820",
    stroke: "#293241"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 11.5,
    fill: "#ED0820"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 8.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004561);
export default __webpack_public_path__ + "static/media/Group 1000004561.18cdfc461a43a86b0987d3b6c0cf0629.svg";
export { ForwardRef as ReactComponent };